<template>
    <div v-if="step.type === 'video'" class="container-fluid bg-light">
        <div class="row justify-content-center">
            <div :id="'youtube' + step.id" class=""></div>
        </div>
    </div>
    <div v-else-if="step.type === 'audio'" class="container-fluid bg-light">
        <div class="container p-5">
            <AudioPlayer :content="step.content" :step-id="step.id" v-on:started="startCountdown"></AudioPlayer>
        </div>
    </div>
    <div v-else-if="step.type === 'text'" class="container bg-light p-4">
        <div v-html="step.content"></div>
    </div>
</template>

<script>
    import YoutubeApi from "../services/YoutubeApi"
    import AudioPlayer from "./AudioPlayer"

    export default {
        components: {
            AudioPlayer
        },

        data() {
            return {}
        },

        mounted() {
            switch (this.step.type) {
                case 'video':
                    YoutubeApi.setStepId(this.step.id)
                    YoutubeApi.setDivId('youtube' + this.step.id)
                    YoutubeApi.setVideoId(this.step.content.video)
                    YoutubeApi.setStartTime(this.step.content.start)
                    YoutubeApi.setEndTime(this.step.content.end)
                    YoutubeApi.renderVideo()
                    break

                case 'audio':
                    break;

                default:
                    this.startCountdown()
            }

            document.addEventListener("youtube-playing", () => {
                this.startCountdown()
            });
        },

        props: {
            step: Object
        },

        computed: {},

        methods: {
            startCountdown() {
                this.$emit('start-countdown')
            }
        }
    }
</script>
